import { v4 as uuidv4 } from 'uuid';

export function ProductInstallmentsListItem(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductInstallmentsListItem',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				markers: [],
				blockClass: '',
				message: '',
			},
			props,
		),
		childrenComponents,
	};
}
